import InnerHeader from "../../Layouts/InnerHeader"
import { useState } from "react"
import { toast } from 'react-toastify';
import { ProductRequest, useCreateProductMutation, useGetProductCatsQuery } from "../../Redux/Apis/productApi";
import { useNavigate } from "react-router-dom";
import MediaGallery from "../../Components/MediaGallery";
import { FormImageGallery } from "../../Components/FormImageGallery";
import TextEditor from "../../Components/TextEditor";

export default function ProductCreate() {
    const navigate = useNavigate()
    const [create,{isLoading : isPostLoading}] = useCreateProductMutation()
    const [errorMsg, setErrorMsg] = useState<any>(false)
    const [isMediaGalleryOpen, setIsMediaGalleryOpen] = useState<boolean>(false);
    const handleImageSelection = (imageUrl: string): void => {
        setFormState((prev) => ({ ...prev, 'images': imageUrl }))
        setIsMediaGalleryOpen(false);
    };
    const {
        data: categories,
        isLoading: isCatLoading,
    } = useGetProductCatsQuery({})
    
    const [formState, setFormState] = useState<ProductRequest>({
        name: "",
        description: "",
        images: "",
        price: NaN,
        sale_price: NaN,
        quantity: NaN,
        detail: "", 
        status: "",
        cat_id: null
    })

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const handleNumChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: +value }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            const prod = await create(formState).unwrap()
            navigate(`/product/${prod.id}`)
            toast.success('محصول با موفقیت ایجاد شد');
            setErrorMsg(false) 
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }
    
    return(
        <div className="container-lg">
            <InnerHeader name={`ایجاد محصول جدید فروشگاه`}/>
            {errorMsg && <div className="alert alert-danger" role="alert">
                {errorMsg}
            </div>}
            <div className="row">
                <div className="col-md-8 col-sm-12 py-0 ps-0 pe-lg-3">
                    <form onSubmit={onSubmit} id="blogForm">
                        <div className="mb-3">
                            <label htmlFor="exampleFormControlInput1" className="form-label">نام محصول</label>
                            <input type="text" name="name" className="form-control" id="exampleFormControlInput1" onChange={handleChange} defaultValue={formState.name}/>
                        </div>
                        <label htmlFor="desc-input" className="form-label">توضیحات محصول</label>
                    </form>
                    <TextEditor id="desc-input" data={formState.description} setFormState={setFormState} name='description'/>
                    
                </div>
                <div className="col-md-4 col-sm-12 bg-light border mt-2 rounded-3 ms-auto p-2">
                <form id="blogForm">
                    <ul className="list-group">
                        <li className="list-group-item">
                            <FormImageGallery _key='images' name='تصویر محصول' value={formState.images} input='images' openMediaGallery={setIsMediaGalleryOpen}/>
                        </li>
                        <li className="list-group-item">
                            <div className="mb-3">
                                <label htmlFor="excerptInput" className="form-label">متن خلاصه (پیشنمایش)</label>
                                <textarea name="detail" className="form-control" id="excerptInput" onChange={handleChange} defaultValue={formState.detail} rows={4}/>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <div className="mb-3">
                                <label htmlFor="price-input" className="form-label">قیمت:</label>
                                <input name="price" type="number" className="form-control" id="price-input" min={0} max={9999999999} step={1} lang="en" onChange={handleNumChange} defaultValue={Number.isNaN(formState.price) ? "" : formState.price}/>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <div className="mb-3">
                                <label htmlFor="sale-price-input" className="form-label">قیمت با تخفیف:</label>
                                <input name="sale_price" type="number" className="form-control" min={0} max={9999999999} step={1} lang="en" id="sale-price-input" onChange={handleNumChange} defaultValue={Number.isNaN(formState.sale_price) ? "" : formState.sale_price}/>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <div className="mb-3">
                                <label htmlFor="quantity-input" className="form-label">موجودی محصول:</label>
                                <input name="quantity" type="number" className="form-control" min={0} step={1} lang="en" id="quantity-input" onChange={handleNumChange} defaultValue={Number.isNaN(formState.quantity) ? "" : formState.quantity}/>
                            </div>
                        </li>
                        <li className="list-group-item">
                            <label className="form-label" htmlFor="inputGroupSelect01">دسته بندی</label>
                            <select name='cat_id' onChange={(e) => setFormState((prev) => ({ ...prev, 'cat_id': +e.target.value }))} defaultValue={formState.cat_id ? +formState.cat_id : ""} className="form-select" id="inputGroupSelect01">
                                <option>انتخاب دسته</option>
                                {
                                    isCatLoading ? 
                                        <option>در حال لود دسته ها...</option>
                                    : 
                                        categories && Object.values(categories).map((value:any,index:number) => 
                                            <option value={value.id} key={index}>{value.name}</option> )
                                }
                            </select>
                        </li>
                        <li className="list-group-item">
                            <div className="mb-3">
                                <label htmlFor="statusInput" className="form-label">وضعیت انتشار</label>
                                <select className="form-select" id="statusInput" name="status" aria-label="select status" onChange={(e) => setFormState((prev) => ({ ...prev, 'status': e.target.value }))} defaultValue={formState.status}>
                                    <option>انتخاب وضعیت</option>
                                    <option value="CONFIRMED">تایید شده</option>
                                    <option value="NOT_CHECKED">در دست بررسی</option>
                                </select>
                            </div>
                        </li>
                        <li className="list-group-item text-end">
                            <button type="submit" form='blogForm' disabled={isPostLoading} className="btn btn-success">ذخیره تغییرات</button>
                        </li>
                    </ul>
                    </form>
                </div>
            </div>
            {isMediaGalleryOpen && (
                <MediaGallery
                    isOpen={isMediaGalleryOpen}
                    onClose={() => setIsMediaGalleryOpen(false)}
                    onImageSelect={handleImageSelection}
                />
            )}
        </div>
    )
}